import { DataForPointConversion } from "~/_legacy/types/shape";

export const CAMERA_ICON_CIRCLE_RADIUS = 4.2;

export const CAMERA_ICON_WIDTH = 52;

export const CROP_CANVAS_CORNER_RADIUS = 5;

export const CROP_CANVAS_CORNER_SIZE = 10;

export const CROP_CANVAS_DEFAULT_WIDTH = 868;

export const CROP_CANVAS_DEFAULT_HEIGHT = 595;

export const CROP_CANVAS_IMAGE_PADDING = 5;

export const CROP_CANVAS_MOUSE_BUFFER = 8;

export const CROP_CANVAS_POINT_TYPES = {
  ltr: 1,
  trb: 2,
  lrb: 3,
  ltb: 4,
  ltrb: 5,
  rb: 6,
  lb: 7,
  tr: 8,
  lt: 9,
} as const;

export const CROP_CANVAS_RESIZER_WIDTH = 2;

export const DEFAULT_BACKGROUND_IMAGE_WIDTH = 1500;

export const DEFAULT_DATA_FOR_POINT_CONVERSION: DataForPointConversion = {
  rendererViewportSize: { width: 0, height: 0 },
  rendererViewportSizeScale: 1,
  backgroundImageSize: { width: 0, height: 0 },
  backgroundImageScaledSize: { width: 0, height: 0 },
};

export const FLOOR_PLAN_MEMO_RELATED_COLORS = [
  "#FF7152",
  "#FFAA2C",
  "#C3E300",
  "#4EDE99",
  "#00ACA2",
  "#5FB3FF",
  "#2147A7",
  "#7C79FF",
  "#E561C8",
  "#FFFFFF",
  "#000000",
];

export const DEFAULT_FLOOR_PLAN_MEMO_DIAGRAM_STYLE = {
  fill: FLOOR_PLAN_MEMO_RELATED_COLORS[0],
  borderColor: undefined,
  opacity: 0.3,
};

export const DEFAULT_FLOOR_PLAN_MEMO_TEXT_STYLE = {
  fontSize: 14,
  color: "#000000",
  opacity: 1,
  hasStroke: false,
  width: 100,
};

export const RENDERABLE_Z_INDEX = {
  floorPlanMemoDiagramShape: 10,
  floorPlanMemoTextShape: 11,
  cameraShape: 20,
  countingLineShape: 30,
  intervalZoneShape: 31,
};

export const SLOT_SIZE = {
  width: 232,
  height: 144,
};

export const SLOT_LAYOUT_VALUES = {
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 10,
  paddingRight: 46,
  minGap: 10,
};
